import { useI18n } from '../../i18n'

type EntryActionsProps = {
   onEdit: () => void
   onDelete: () => void
   /** Accessible label for the edit button (defaults to "Edit"). */
   editLabel?: string
}

/**
 * Renders the compact edit (pencil) and delete (bin) icon buttons used by the
 * entry lists.
 *
 * @param props - The handlers and optional edit label.
 * @returns The button group element.
 */
const EntryActions = (props: EntryActionsProps) => {
   const t = useI18n()

   return (
      <div class="flex gap-2">
         <button
            type="button"
            onClick={props.onEdit}
            class="p-2 rounded-md bg-blue-600 text-action-icon hover:bg-blue-700"
            aria-label={props.editLabel ?? t('Edit')}
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="18"
               height="18"
               viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor"
               stroke-width="2"
               stroke-linecap="round"
               stroke-linejoin="round"
            >
               <path d="M17 3l4 4-11 11H6v-4z" />
               <path d="M15 5l4 4" />
            </svg>
         </button>
         <button
            type="button"
            onClick={props.onDelete}
            class="p-2 rounded-md bg-red-600 text-action-icon hover:bg-red-700"
            aria-label={t('Delete')}
         >
            <svg
               xmlns="http://www.w3.org/2000/svg"
               width="20"
               height="20"
               viewBox="0 0 24 24"
               fill="none"
               stroke="currentColor"
               stroke-width="1.8"
               stroke-linecap="round"
               stroke-linejoin="round"
            >
               <path d="M3 6h18" />
               <path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
               <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
               <path d="M10 11v6" />
               <path d="M14 11v6" />
            </svg>
         </button>
      </div>
   )
}

export default EntryActions
